"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const ModalPortal_1 = __importDefault(require("@App/kit/components/Popups/ModalPortal"));
const PointPreloader_1 = __importDefault(require("@App/kit/components/Preloaders/PointPreloader"));
const contexts_1 = require("@App/contexts");
const RoyaltiesSidebar_1 = __importDefault(require("@Components/Sidebars/RoyaltiesSidebar"));
const RightsholderRoyaltiesHead_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyalties/RightsholderRoyaltiesHead"));
const RoyaltiesUsagePeriod_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyalties/RoyaltiesUsagePeriod"));
const dayjs_1 = __importDefault(require("dayjs"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const react_error_boundary_1 = require("react-error-boundary");
const RightsholderRoyalties = () => {
    const { statementsStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const handleError = (0, react_error_boundary_1.useErrorHandler)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [sidebarIsOpen, setSidebarIsOpen] = (0, react_1.useState)(false);
    const [usagePeriod, setUsagePeriod] = (0, react_1.useState)();
    const [pdfString, setPdfString] = (0, react_1.useState)('');
    const [selectedData, setSelectedData] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        setLoading(true);
        if (usagePeriod) {
            const thisUsagePeriod = (0, dayjs_1.default)(usagePeriod.value, 'MM-YYYY');
            // Reformat Usage Period String To Long-Year, 2-Char Month For PDF Downloads
            setPdfString(`${thisUsagePeriod.format('YYYYMM')}.pdf`);
            statementsStore.clearRoyalties();
            const year = thisUsagePeriod.format('YYYY');
            const month = thisUsagePeriod.format('MM');
            Promise.all([
                statementsStore.loadRoyalties(year, month),
                statementsStore.loadDistributionSummaryPdfLink(year, month),
            ]).finally(() => setLoading(false));
        }
    }, [usagePeriod]);
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_royalties');
        setLoading(true);
        statementsStore.clearRoyalties();
        // Start loading up the latest date
        statementsStore
            .loadLatestRoyaltiesDate()
            .catch((reason) => {
            handleError(reason);
        })
            .then(() => {
            setUsagePeriod(statementsStore.royaltiesUsagePeriodOptions[0]);
        })
            .finally(() => setLoading(false));
        return () => statementsStore.clearRoyalties();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Royalties Summary' }),
        react_1.default.createElement("div", { className: "royalties-summary-wrapper" },
            react_1.default.createElement("div", { className: 'global-container' },
                react_1.default.createElement(RightsholderRoyaltiesHead_1.default, { setUsagePeriod: setUsagePeriod, usagePeriod: usagePeriod }),
                react_1.default.createElement("div", { className: 'preloader-container' }, loading && react_1.default.createElement(PointPreloader_1.default, null)),
                !loading && (react_1.default.createElement(RoyaltiesUsagePeriod_1.default, { usagePeriod: usagePeriod, pdfString: pdfString, setSelectedData: setSelectedData, setSidebarIsOpen: setSidebarIsOpen })))),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: sidebarIsOpen, onClose: () => setSidebarIsOpen(false) },
            react_1.default.createElement(RoyaltiesSidebar_1.default, { closeSidebar: () => setSidebarIsOpen(false), data: selectedData }))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderRoyalties);
